export function grow(mainSelector, blockSelector) {
  const growDiv = document.getElementById(mainSelector);
  if (growDiv.clientHeight) {
    growDiv.style.height = 0;
  } else {
    const wrapper = document.querySelector(`.${blockSelector}`);
    growDiv.style.height = `${wrapper.clientHeight}px`;
  }
}

export function growTrials(mainSelector, grow_height) {
  const growDiv = document.getElementById(mainSelector);
  growDiv.style.height = `${grow_height}px`;
}
